import { ApiError } from "./api";

const MESSAGES: Record<string, string> = {
  unauthorized: "Relácia vypršala. Prihláste sa znova.",
  number_taken: "Toto číslo faktúry je už použité. Zvoľte iné.",
  customer_not_found: "Odberateľ neexistuje. Vyberte zo zoznamu.",
  customer_id_required: "Vyberte odberateľa.",
  customer_id_invalid: "Neplatný odberateľ.",
  status_invalid: "Neplatný stav faktúry.",
  items_invalid: "Skontrolujte položky faktúry.",
  bad_body: "Neplatné údaje formulára.",
  bad_date: "Neplatný dátum.",
  no_supplier: "Najprv nastavte dodávateľa v Nastaveniach.",
  only_drafts_deletable: "Vystavené faktúry nemôžete zmazať.",
  insert_failed: "Uloženie zlyhalo. Skúste znova.",
  not_found: "Nenájdené.",
  invoice_locked:
    "E-faktúra k tejto faktúre už bola exportovaná — faktúru nemožno meniť ani zmazať. Opravu riešte dobropisom.",
  einvoice_exists: "E-faktúra k tejto faktúre už bola exportovaná.",
  not_issued: "E-faktúru možno vytvoriť len z vystavenej faktúry.",
  einvoice_invalid: "E-faktúra sa nepodarila uložiť (neplatné XML).",
};

export function describeError(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code && MESSAGES[err.code]) return MESSAGES[err.code]!;
    if (err.status === 0 || err.status >= 500)
      return "Server nedostupný. Skúste o chvíľu znova.";
    if (err.status === 409) return "Konflikt — záznam už existuje.";
    return err.message || `Chyba ${err.status}`;
  }
  if (err instanceof Error) return err.message;
  return String(err);
}
